import { Clickable } from '@ahmdigital/ui';
import { compact, flow, map, sortBy, uniqBy } from 'lodash/fp';

import getSaleableProductIdsKeyedByType from '../../../../utils/get-saleable-product-ids-keyed-by-type';
import ProductService from '../../../../models/product';
import UrlService from '../../../../models/url';

type ProductsByTypeProps = {
  products: {};
  type: string;
};

const ProductsByType = ({ type, products }: ProductsByTypeProps) => (
  <ul>
    {flow(
      map((productId) => ProductService.getProduct(products, productId)),
      compact,
      sortBy('rank'),
      // @ts-expect-error - Automatic, Please fix when editing this file
      map(({ id, name }) => ({
        id,
        name,
        url: UrlService.getProductUrl(id),
      })),
      uniqBy('url'),
      // @ts-expect-error - Automatic, Please fix when editing this file
      map(({ id, name, url }) => (
        <li key={id}>
          <Clickable to={url}>{name}</Clickable>
        </li>
      )),
      // @ts-expect-error - Automatic, Please fix when editing this file
    )(getSaleableProductIdsKeyedByType()[type])}
  </ul>
);

export default ProductsByType;
